import { Component, Input, Output, EventEmitter } from '@angular/core';
import { LegendItem } from '../../models/legend-item';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatCheckbox } from '@angular/material/checkbox';
import { FormsModule } from '@angular/forms';
import { NgStyle } from '@angular/common';

@Component({
  selector: 'legend-item',
  templateUrl: './legend-item.component.html',
  styleUrls: ['./legend-item.component.scss', '../../scss/operational-dashboard-shared.scss'],
  imports: [MatButton, MatIcon, MatCheckbox, FormsModule, NgStyle]
})
export class LegendItemComponent {
  @Input() legendItems: LegendItem[];
  @Input() showFilter: boolean = true;
  @Output() selectionChangedEvent = new EventEmitter<any>();

  

  triggerChangedEvent(event) {
    this.selectionChangedEvent.emit(event);
  }

  resetFilters() {
    this.legendItems.forEach(item => item.visible = true);
    this.triggerChangedEvent(null);
  }
}
